// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminModeController from "./admin_mode_controller"
application.register("admin-mode", AdminModeController)

import BackButtonController from "./back_button_controller"
application.register("back-button", BackButtonController)

import BulkActionsController from "./bulk_actions_controller"
application.register("bulk-actions", BulkActionsController)

import BulkUploadController from "./bulk_upload_controller"
application.register("bulk-upload", BulkUploadController)

import DiscoveryChannelController from "./discovery_channel_controller"
application.register("discovery-channel", DiscoveryChannelController)

import DiscoveryFormController from "./discovery_form_controller"
application.register("discovery-form", DiscoveryFormController)

import DiscoveryMapController from "./discovery_map_controller"
application.register("discovery-map", DiscoveryMapController)

import DiscoveryShowController from "./discovery_show_controller"
application.register("discovery-show", DiscoveryShowController)

import DistanceController from "./distance_controller"
application.register("distance", DistanceController)

import ExplanationBackfillPollController from "./explanation_backfill_poll_controller"
application.register("explanation-backfill-poll", ExplanationBackfillPollController)

import ExplanationPollController from "./explanation_poll_controller"
application.register("explanation-poll", ExplanationPollController)

import FeedLocationController from "./feed_location_controller"
application.register("feed-location", FeedLocationController)

import FloatingModalController from "./floating_modal_controller"
application.register("floating-modal", FloatingModalController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LogoutController from "./logout_controller"
application.register("logout", LogoutController)

import MapController from "./map_controller"
application.register("map", MapController)

import NavbarBurgerController from "./navbar_burger_controller"
application.register("navbar-burger", NavbarBurgerController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import PersonaAdminController from "./persona_admin_controller"
application.register("persona-admin", PersonaAdminController)

import ProfileEditController from "./profile_edit_controller"
application.register("profile-edit", ProfileEditController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import TagInputController from "./tag_input_controller"
application.register("tag-input", TagInputController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import UserSearchController from "./user_search_controller"
application.register("user-search", UserSearchController)
